const isN = v => typeof v === 'number'

function computeTotal ({ items }) {
  return items.reduce((total, { subtotal }) => (isN(subtotal) ? total + subtotal : total), 0)
}

const unitMap = { A: '支', B: '片' }
const getUnit = ({ type }) => unitMap[type]
function computeSummary ({ items }) {
  const qtyMap = items.reduce((accumulator, { qty, productRef }) => {
    if (!productRef) return accumulator
    if (!isN(qty) || qty === 0) return accumulator

    const unit = getUnit(productRef)
    if (!unit) return accumulator

    return {
      ...accumulator,
      [unit]: (accumulator[unit] || 0) + qty,
    }
  }, { })

  return Object.keys(qtyMap).map(unit => `${qtyMap[unit]} ${unit}`).join(' ')
}

export { computeTotal, computeSummary }



// WEBPACK FOOTER //
// ./src/components/PurchaseOrderEditor/computeValue.js